import { getCurrentInstance, onBeforeUnmount, onMounted, ref } from "vue";
export function useDropdown() {
  const isOpen = ref(false);
  function toggle(force) {
    if (typeof force === "boolean") {
      isOpen.value = force;
      return;
    }
    isOpen.value = !isOpen.value;
  }
  const instance = getCurrentInstance()?.proxy;
  function onClick(e) {
    if (instance?.$el.contains(e.target)) {
      return;
    }
    toggle(false);
  }
  onMounted(() => {
    window.addEventListener("click", onClick);
  });
  onBeforeUnmount(() => {
    window.removeEventListener("click", onClick);
  });
  return {
    isOpen,
    toggle
  };
}
